export default __webpack_public_path__ + "static/media/team.874b87e9.png";